import React from 'react';

import './grid-layout.less';

function GridLayout(props) {
    return (
        <div className={'grid-layout'}>
            {props.children}
        </div>
    );
}

export default GridLayout;



// WEBPACK FOOTER //
// ./src/universal/components/grid-layout/grid-layout.js